module.exports = __webpack_public_path__ + "img/img128.0f6bbe02.svg";